// import {getOrganizerArticlesForPlaceId} from './api';
import { setWindowLocation } from '@eb/http';
import { followOrganizer as followOrganizerApi } from '../organizers/api';
import { SET_ORGANIZER_ARTICLES, FOLLOW_ORGANIZER } from './actionTypes';
import { storeOrganizerToFollow } from '../../utils/sessionStorage';
import { transformFiveToFollowResponse } from '../utils';
import { setOrganizerArticlesLoading } from '../app/actions';
import { getFiveToFollowContent } from '../../utils/content';
import { addOrganizersUsersFollow } from '../organizers/actions';

const setOrganizerArticles = (data) => ({
    type: SET_ORGANIZER_ARTICLES,
    payload: transformFiveToFollowResponse(data),
});

const setFollowOrganizer = (id, value) => ({
    type: FOLLOW_ORGANIZER,
    payload: {
        id,
        value,
    },
});

export const addOrganizerArticles = (locationData) => (dispatch, getState) => {
    const { location: userLocation } = getState();
    const { placeId } = locationData || userLocation;
    const data = getFiveToFollowContent(placeId);

    dispatch(setOrganizerArticlesLoading(true));

    dispatch(setOrganizerArticles(data));

    return dispatch(setOrganizerArticlesLoading(false));
    // The next block will be commented until the unblock for the core releases
    // return getOrganizerArticlesForPlaceId(placeId)
    // .then((response) => {
    //     dispatch(setOrganizerArticles(response));
    //     dispatch(setOrganizerArticlesLoading(false));
    // })
    // .catch(() => {
    //     dispatch(setOrganizerArticles([]));
    // });
};

export const followOrganizer = (id) => (dispatch, getState) => {
    const {
        organizers: { organizersUserFollow },
        user: { isAuthenticated },
    } = getState();

    const organizerIds = organizersUserFollow;

    if (isAuthenticated) {
        followOrganizerApi(id).then(() => {
            organizerIds.push(id);

            dispatch(setFollowOrganizer(id, true));
            dispatch(addOrganizersUsersFollow(organizerIds));
        });
    } else {
        storeOrganizerToFollow({ organizerToFollow: id });
        setWindowLocation('/login/?referrer=%2F');
    }
};
